// Auto-generated section component extracted from Landing.jsx
import React from "react";

export default function PlansSection({ api }) {
  const { memberPackages, membershipTiers, t } = api || {};
  return (
<section id="plans" className="space-y-6">
                <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
                  {t.membership.heading}
                </h2>

                <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4">
                  <p className="text-slate-200 text-sm sm:text-base max-w-4xl">
                    {t.membership.intro}
                  </p>

                  <div className="rounded-2xl border border-emerald-500/40 bg-emerald-500/10 p-4">
                    <div className="text-sm font-semibold text-emerald-300">
                      {t.membership.disclosureTitle}
                    </div>
                    <div className="mt-1 text-xs text-slate-200">
                      {t.membership.disclosureBody}
                    </div>
                  </div>

                  <div>
                    <div className="text-sm font-semibold text-slate-100 mb-3">
                      {t.membership.tiersHeading}
                    </div>
                    <div className="grid gap-3 md:grid-cols-2">
                      {membershipTiers.map((tier) => (
                        <div
                          key={tier.name}
                          className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4"
                        >
                          <div className="flex items-start justify-between gap-2">
                            <div>
                              <div className="text-slate-50 font-semibold">
                                {tier.name}
                              </div>
                              {tier.subtitle ? (
                                <div className="text-xs text-slate-300 mt-1">
                                  {tier.subtitle}
                                </div>
                              ) : null}
                            </div>
                            <div className="text-emerald-300 font-semibold text-right">
                              {tier.amount}
                            </div>
                          </div>
                          <div className="mt-2 text-[11px] text-slate-300">
                            {tier.tag}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div>
                    <div className="text-sm font-semibold text-slate-100 mb-3">
                      {t.membership.packagesHeading}
                    </div>
                    <div className="grid gap-3 lg:grid-cols-3">
                      {memberPackages.map((p) => (
                        <div
                          key={p.title}
                          className={`rounded-3xl border ${p.accent} bg-[#010916]/78 p-5`}
                        >
                          <div className={`font-semibold ${p.head}`}>
                            {p.title}
                          </div>
                          <div className="text-xs text-slate-200 mt-1">
                            {p.price}
                          </div>
                          <ul className="mt-3 space-y-1 text-xs text-slate-200">
                            {p.bullets.map((b) => (
                              <li key={b}>• {b}</li>
                            ))}
                          </ul>
                          {p.note ? (
                            <div className="mt-3 text-[11px] text-slate-300">
                              {p.note}
                            </div>
                          ) : null}
                          {p.finePrint ? (
                            <div className="mt-2 text-[11px] text-slate-300">
                              {p.finePrint}
                            </div>
                          ) : null}
                          {p.highlight ? (
                            <div className="mt-3 text-[11px] text-emerald-300">
                              {p.highlight}
                            </div>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
                    <div className="text-sm font-semibold text-slate-100">
                      {t.membership.taxHeading}
                    </div>
                    <div className="mt-1 text-xs text-slate-200">
                      {t.membership.taxBody}
                    </div>
                    {t.membership.taxFinePrint ? (
                      <div className="mt-2 text-[11px] text-slate-300">
                        {t.membership.taxFinePrint}
                      </div>
                    ) : null}
                  </div>
                </div>
              </section>
  );
}
